import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { getStaticAssetPath } from '@/lib/utils';

type HeaderLogoProps = {
  href: string;
  size?: 'sm' | 'md';
};

const sizeStyles = {
  sm: {
    imageSize: 28,
    textClass: 'text-2xl',
  },
  md: {
    imageSize: 32,
    textClass: 'text-2xl',
  },
};

export const HeaderLogo = ({ href, size = 'md' }: HeaderLogoProps) => {
  const { imageSize, textClass } = sizeStyles[size];

  return (
    <div className='flex items-center gap-2'>
      <Image
        src={getStaticAssetPath('/static/siteLogo.svg')}
        alt='DarPiano Logo'
        className='h-8 w-auto'
        width={imageSize}
        height={imageSize}
      />
      <Link href={href} className={`${textClass} font-light`}>
        DarPiano
      </Link>
    </div>
  );
};
